module.exports = __webpack_public_path__ + "images/9884de4e7380471babb94a7cb9ebd3bf913a64ce4228fd63f284d4e85d66f829.svg";